<div *ngIf="this.clientId > 0 && !!showClientInfo" class="infoPanel apptBookerComponents">
    <div class="infoPanelDetails" title="">
        <div class="field">
            <div class="field-label">Client Name</div>
            <div class="field-value"
                title="{{clientInfo?.Title}} {{clientInfo?.FirstName}} {{clientInfo?.MiddleNames}} {{clientInfo?.LastName}}">
                {{clientInfo?.Title }} {{clientInfo?.FirstName}}
                {{clientInfo?.MiddleNames}}
                {{clientInfo?.LastName}}</div>
        </div>
        <div class="field">
            <div class="field-label">Address</div>
            <div class="field-value" title="{{clientInfo?.Address}}">{{clientInfo?.Address}}</div>
        </div>
        <div class="field">
            <div class="field-label">Mobile</div>
            <div class="field-value">{{clientInfo?.MobileTelephone}}</div>
        </div>
        <div class="field">
            <div class="field-label">Email Address</div>
            <div class="field-value" title="{{clientInfo?.EmailAddress}}">{{clientInfo?.EmailAddress}}</div>
        </div>
        <div class="field">
            <div class="field-label">Client Number</div>
            <div class="field-value">{{clientInfo?.ClientNumber}}</div>
        </div>
        <div class="field">
            <div class="field-label">Skin Type</div>
            <div class="field-value">{{clientInfo?.SkinType}}</div>
        </div>
        <div class="field">
            <div class="field-label">Credits
            </div>
            <div class="field-value">
                <span>{{clientInfo?.TotalCredits === 0 && clientInfo?.CreditsDescription.includes('Unlimited') ?
                    'Unlimited' : clientInfo?.TotalCredits}}</span><span>{{creditSystemName}}</span>
            </div>
            <div id="creditInfoIconContainer">
                <div *ngIf="clientInfo?.TotalCredits>0 || clientInfo?.CreditsDescription.includes('Unlimited')"
                    id="creditInfoIcon" class="material-icons md-16">
                    info_outline
                </div>
                <dx-popover 
                    *ngIf="clientInfo?.TotalCredits>0 || clientInfo?.CreditsDescription.includes('Unlimited')"
                    target="#creditInfoIconContainer" 
                    showEvent="mouseenter" 
                    title="Credits Details"
                    [showTitle]="true" 
                    width="450"
                    [wrapperAttr]="{ id: 'creditInfoPopover' }"
                    (onShowing)="onPopoverShowing($event)"
                    (onHiding)="onPopoverHiding($event)"
                >
                    <div *dxTemplate="let data of 'content'" id="temp123" class="temp123">
                        <div [innerHTML]="clientInfo?.CreditsDescription"></div>
                    </div>
                </dx-popover>
            </div>
        </div>
        <div class="field">
            <div class="field-label">Last Session</div>
            <div class="field-value" title="{{lastSessionDetails}}">
                {{lastSessionDetails}}
            </div>
        </div>
        <div class="field">
            <div class="field-label">Last Visited</div>
            <div class="field-value">{{clientInfo?.LastSessionDate| date:"E d MMM yyyy HH:mm"}}</div>
        </div>
        <div class="field">
            <div class="field-label">Date of Birth</div>
            <div *ngIf="!isBirthday" class="field-value">{{clientInfo?.DateOfBirth | date: 'E d MMM yyyy'}} {{ age ? '(' + age + ')' : ''}}</div>
            <div *ngIf="isBirthday" class="field-value">
                <span style="color: red;">{{dobDayAndMonth}}</span>
                <span> {{dobYear}}</span>
                <span> {{ age ? '(' + age + ')' : ''}}</span>
            </div>
        </div>
    </div>
    <div class="cmdPanel" title="" style="min-width: 150px; min-height: 170px;">
        <img [src]="clientPhotoUrl" width="140" height="140" alt="Client Photo" />

        <div
            style="display: flex; display: flex; flex-direction: row; justify-content: flex-start; align-items: center; min-height: 36px; width: 100%; padding-top:2px">
            <dx-button class="apptBookerButton clientInfoBtn" (onClick)="btnShowClientDetails($event)" hint="Edit Client" [visible]="showEditClientBtn"
                [width]="32" [height]="32">
                <i class="dx-icon dx-icon-edit clientInfoBtnIcon">                    
                </i>
            </dx-button>
            <dx-button class="apptBookerButton clientInfoBtn" [disabled]="!HasNotes()" (onClick)="btnShowNotes($event)"
                [width]="32" [height]="32" hint="View Client Notes">            
                <i class="dx-icon dx-icon-alignleft clientInfoBtnIcon">                    
                </i>
            </dx-button>
            <dx-button *ngIf="!HasUrgentNotes()" class="apptBookerButton clientInfoBtn" [disabled]="!HasUrgentNotes()" [width]="32" [height]="32"
                (onClick)="btnShowUrgentNotes($event)" hint="View Client Urgent Notes">
                <i class="dx-icon dx-icon-warning clientInfoBtnIcon">
                </i>
            </dx-button>
            <dx-button *ngIf="HasUrgentNotes()" class="apptBookerButton clientInfoBtn" style="background-color: red; color: white;"
                [width]="32" [height]="32" [disabled]="!HasUrgentNotes()" (onClick)="btnShowUrgentNotes($event)"
                hint="View Client Urgent Notes">
                <i class="dx-icon dx-icon-warning clientInfoBtnIcon">
                </i>
            </dx-button>
        </div>
    </div>
</div>
<app-notes-viewer></app-notes-viewer>
<app-client-editor (CloseDlg)="OnCloseDlg($event)"></app-client-editor>